<template>
    <div class="autobookpro-page-content">
        <div v-for="survey in surveys" :key="survey.id">
            <p>Order: {{ survey.orderId }}</p>
            <p>Review: {{ survey.note }}</p>
            <p>Rating: {{ survey.rating }}</p>
            <p>Submitted At: {{ survey.createdAt }}</p>
            <br/>
        </div>
    </div>
  </template>

  <script>
  import graphql from '@client/graphql';

  export default {
    metaInfo: {
      title: 'AutoBook Pro - Survey List'
    },
    apollo: {
      surveys: {
        query: graphql.queries.loadSurveys
      }
    },
    data() {
      return {
        loading: false,
        error: null
      };
    }
  };
  </script>

  <style></style>
